import { useState } from "react";
import styles from "./CollapsibleMultiselect.module.scss";
import { List, ListItemText } from "@mui/material";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";

interface Props {
  listName: string;
  items: string[] | undefined;
  selectedItems: string[];
  readonly: boolean;
  onChangeSelected: (selected: string[]) => void;
  getLabel?: (item: string) => string;
}

const CollapsibleMultiselect: React.FC<Props> = ({
  listName,
  items,
  selectedItems,
  readonly,
  onChangeSelected,
  getLabel,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapsible = () => {
    setIsOpen(!isOpen);
  };

  const handleItemClick = (itemId: string) => {
    if (selectedItems.includes(itemId)) {
      onChangeSelected(selectedItems.filter((selectedItem) => selectedItem !== itemId));
    } else {
      onChangeSelected([...selectedItems, itemId]);
    }
  };

  return (
    <div className={styles.collapsible}>
      <div onClick={toggleCollapsible} className={styles.header}>
        <p className={styles.listName}>{listName}</p>
        <div className={styles.icon}>{isOpen ? <ExpandLess /> : <ExpandMore />}</div>
      </div>
      {isOpen && (
        <List>
          {items?.map((item) => (
            <ListItemText key={`${listName}_${item}`}>
              <input
                disabled={readonly}
                type="checkbox"
                checked={selectedItems.includes(item)}
                onChange={() => handleItemClick(item)}
              />
              <span className={styles.listItem}>{getLabel ? getLabel(item) : item}</span>
            </ListItemText>
          ))}
        </List>
      )}
    </div>
  );
};

export default CollapsibleMultiselect;
